import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import SignupSuccess from './pages/SignupSuccess';
import NotFound from './pages/NotFound';
import usePageTracking from './hooks/usePageTracking';
import AnalyticsTest from './components/AnalyticsTest';

// Component that uses the page tracking hook
function AppContent() {
  usePageTracking(); // This will track page views automatically
  
  return (
    <div className="App min-h-screen bg-gray-900">
      <Navbar />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/signup-success" element={<SignupSuccess />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </motion.main>
      <Footer />
      <AnalyticsTest />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;